const carousel = () => {
  const carousel = document.getElementById('js-carousel')
  const banner = document.getElementById('js-banner')

  banner &&
    carousel &&
    carousel.querySelectorAll('a').forEach((elm) => {
      elm.addEventListener('mouseover', (e) => {
        for (let i = banner.classList.length - 1; i >= 0; i--) {
          const className = banner.classList[i]

          if (className.startsWith('theme--')) {
            banner.classList.remove(className)
          }
        }

        banner.classList.add(e.target.dataset.theme)

        banner.querySelectorAll('img')[0].src = e.target.dataset.img
          ? e.target.dataset.img
          : banner.dataset.img
      })

      elm.addEventListener('mouseleave', (e) => {
        banner.classList.remove(e.target.dataset.theme)
        banner.querySelectorAll('img')[0].src = banner.dataset.img
      })
    })
}

export default carousel
